/* LOCALIZATION */
export const LOCALIZATION_SET_AVAILABLE_LANGUAGES = 'LOCALIZATION_SET_AVAILABLE_LANGUAGES';
export const LOCALIZATION_SET_LANGUAGE = 'LOCALIZATION_SET_LANGUAGE';
export const LOCALIZATION_SET_LOCALES = 'LOCALIZATION_SET_LOCALES';
